<div class="actions" [dataSelector]="'cxp-crl-panel-item-actions'">
  @if (isNotApplicable()) {
    <p class="actions-na-note">
      This item is marked as not applicable.
      @if (canUndoNotApplicable()) {
        <button
          type="button"
          class="actions-na-undo"
          aria-label="Undo marked as not applicable"
          [disabled]="isUndoPending()"
          [dataSelector]="'cxp-crl-panel-undo-na'"
          (click)="onUndoNotApplicable()"
        >
          Undo
        </button>
      }
    </p>
  }

  @if (!showNoteField()) {
    <div class="actions-row">
      @if (isMarkedFinished()) {
        <span class="actions-finished">
          <aiwyn-icon name="circle-check-fill" class="actions-finished-icon" [height]="20" [width]="20"></aiwyn-icon>
          Marked as Finished
        </span>
      }

      <div class="actions-buttons">
        @if (canMarkNotApplicable()) {
          <button
            andButton
            color="default"
            [disabled]="isSubmitting()"
            [dataSelector]="'cxp-crl-panel-na'"
            (click)="openNoteField()"
          >Mark as Not Applicable</button>
        }

        @if (canMarkFinished()) {
          <!-- A disabled button emits no mouse events, so the tooltip hangs on a
               wrapper (see TooltipDirective's note). -->
          <span
            class="actions-finish-wrap"
            [tooltip]="finishDisabledHint() ?? ''"
            [tooltipEnabled]="!!finishDisabledHint()"
          >
            <button
              andButton
              color="primary"
              [disabled]="isFinishDisabled()"
              [isLoading]="isFinishLoading()"
              [dataSelector]="'cxp-crl-panel-finish'"
              (click)="onFinished()"
            >I'm Finished</button>
          </span>
        }

        @if (canUndoFinished()) {
          <button
            andButton
            color="hyperlink"
            class="actions-undo"
            aria-label="Undo I'm Finished"
            [disabled]="isUndoPending()"
            [dataSelector]="'cxp-crl-panel-undo-finished'"
            (click)="onUndoFinished()"
          >Undo</button>
        }
      </div>
    </div>
  } @else {
    <div class="actions-note">
      <label class="actions-note-label" for="cxp-crl-na-note">Add a note (optional)</label>
      <textarea
        id="cxp-crl-na-note"
        class="actions-note-input"
        rows="3"
        [formControl]="noteControl"
        [dataSelector]="'cxp-crl-panel-na-note'"
      ></textarea>
      <div class="actions-note-row">
        <button
          andButton
          color="primary"
          size="small"
          [disabled]="isSubmitting()"
          [isLoading]="isNotApplicableLoading()"
          [dataSelector]="'cxp-crl-panel-na-confirm'"
          (click)="confirmNotApplicable()"
        >Mark as N/A</button>
        <button
          andButton
          color="ghost-secondary"
          size="small"
          [disabled]="isSubmitting()"
          [dataSelector]="'cxp-crl-panel-na-cancel'"
          (click)="cancelNote()"
        >Cancel</button>
      </div>
    </div>
  }
</div>
